import AuthGuardDisplay from '@components/AuthGuardDisplay';
import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import AccountFooter from './components/AccountFooter';
import AccountManagement from './components/AccountManagement';
import Permissions from './components/Permissions';
import Policies from './components/Policies';

declare module '@stackflow/config' {
    interface Register {
        AccountSettingActivity: {};
    }
}

const AccountSettingActivity: ActivityComponentType<'AccountSettingActivity'> = () => {
    const { t } = useTranslation('accountSetting');
    return (
        <AppScreen>
            <Header title={t('header.title')} noShadow/>
            <Column as='main' spacing={40}>
                <Column fullWidth as='section'>
                    <AuthGuardDisplay>
                        <AccountManagement/>
                        <Permissions/>
                    </AuthGuardDisplay>
                    <Policies/>
                </Column>
                <AccountFooter/>
            </Column>

        </AppScreen>
    );
};

export default AccountSettingActivity;
